// Tipo de pin do local (cs_pin_type). Quem dá o sentido é o app; o backend só repassa.
// 1 = local apenas informativo: vem de base externa (ex.: Open Charge Map pela ChargeMap),
// não aceita recarga pela Spott e só oferece "Como chegar".
export const PIN_TYPE_INFORMATIONAL_ONLY = 1;

// A base externa não informa se o carregador está livre: no lugar dos ícones de status.
export const AVAILABILITY_NOT_INFORMED = 'Disponibilidade não informada';

export const isInformationalSite = (site: any): boolean =>
  site?.csPinType === PIN_TYPE_INFORMATIONAL_ONLY;

// Fonte do local informativo: o nome de exibição da empresa dona, quando ela é parceira OCPI
// (o texto é cadastro do parceiro, ex.: "Open Charge Map (CC BY 4.0)"). Roaming entre empresas da
// própria Spott não mostra nada por enquanto, embora a API já mande o nome.
export const dataSourceOf = (site: any): string | null =>
  isInformationalSite(site) && site?.appExternalOcpi && site?.appDisplayName
    ? `Dados: ${site.appDisplayName}`
    : null;

export const googleMapsSearchUrl = (lat: number, lng: number): string =>
  `https://www.google.com/maps/search/?api=1&query=${lat},${lng}`;
